import React, { useLayoutEffect, useRef, useState } from 'react';

import { Image } from '@change/ds-core-ui';

import { usePageBannerGuestMessage, usePageBannerMessage } from 'src/app/pages/psf/share/shared/hooks';
import { ParallaxWrapper } from 'src/app/shared/components/layout/parallax';
import { useIsMobile } from 'src/app/shared/hooks/userAgent';

import { PageBanner } from '../../../PageBanner';

import { usePetitionMedia } from './hooks/usePetitionMedia';

export const PetitionMedia: React.FC = () => {
	const {
		data: { photo },
	} = usePetitionMedia();

	const message = usePageBannerMessage();
	const guestMessage = usePageBannerGuestMessage();
	const isMobile = useIsMobile();
	const bannerRef = useRef<HTMLDivElement>(null);
	const [bannerHeight, setBannerHeight] = useState(0);

	const hasBanner = !!(message || guestMessage);

	useLayoutEffect(() => {
		if (isMobile && hasBanner && bannerRef.current) {
			setBannerHeight(bannerRef.current.offsetHeight);
			return;
		}

		setBannerHeight(0);
	}, [isMobile, hasBanner]);

	let src = 'https://static.change.org/images/default-petition-darker.gif';
	const dataQa = 'hero-image';

	if (photo) {
		src = isMobile ? photo.mobileUrl : photo.url;
	}

	// Calculate total height: base image height + banner height (on mobile only)
	const mobileImageHeight = 190; // From Tailwind h-[11.88rem] converted to pixels (11.88 * 16 = 190px)
	const totalMobileHeight = mobileImageHeight + bannerHeight;

	return (
		<div className="relative -mb-4">
			<div
				className="relative md:h-[19.57rem]"
				style={isMobile && hasBanner ? { height: `${totalMobileHeight}px` } : undefined}
			>
				<ParallaxWrapper className="relative h-full">
					{/* PageBanner on mobile only - inside parallax effect */}
					{isMobile && (
						<div ref={bannerRef} className="relative z-50">
							<PageBanner />
						</div>
					)}
					<div className="relative md:h-[19.57rem]" style={isMobile ? { height: `${mobileImageHeight}px` } : undefined}>
						<Image
							width="100%"
							height="100%"
							src={src}
							data-qa={dataQa}
							alt=""
							className="md:rounded-t-large h-full w-full object-cover"
						/>
						<div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.15)_50%,rgba(0,0,0,0.4)_80%,rgba(0,0,0,0.7)_100%)]" />
					</div>
				</ParallaxWrapper>
			</div>
		</div>
	);
};
